/**
 * mi-comunidad
 * Version 2.0 de la comunidad
 *
 * The version of the OpenAPI document: 2.54.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InactiveReasonWithRelations } from './inactiveReasonWithRelations';
import { UserTenantWithRelations } from './userTenantWithRelations';
import { BusinessUnitWithRelations } from './businessUnitWithRelations';
import { CityWithRelations } from './cityWithRelations';
import { CompanyWithRelations } from './companyWithRelations';
import { JobPositionWithRelations } from './jobPositionWithRelations';
import { DepartmentWithRelations } from './departmentWithRelations';
import { UserCredentialsWithRelations } from './userCredentialsWithRelations';
import { JobCategoryWithRelations } from './jobCategoryWithRelations';
import { AreaWithRelations } from './areaWithRelations';
import { PersonalRequisitionWithRelations } from './personalRequisitionWithRelations';
import { VacancyWithRelations } from './vacancyWithRelations';


/**
 * (tsType: UserWithRelations, schemaOptions: { includeRelations: true })
 */
export interface UserWithRelations { 
    deleted?: boolean;
    deletedOn?: string | null;
    deletedBy?: string | null;
    createdOn?: string;
    modifiedOn?: string;
    createdBy?: number;
    modifiedBy?: number;
    id?: number;
    firstName: string;
    hasWhatsApp?: boolean;
    lastName?: string;
    middleName?: string;
    username: string;
    email?: string;
    phone?: string;
    defaultTenant?: number;
    lastLogin?: string;
    dateBirth?: string;
    dateAdmission?: string;
    recognitionDate?: string;
    enrollment?: string | null;
    isDefaultEnrollment?: boolean;
    isSystemAccount?: boolean;
    rfc?: string;
    curp?: string;
    imss?: string;
    address?: string;
    residence?: string;
    departmentName?: string;
    photoProfileUrl?: string;
    uuid?: string;
    companyId: string;
    homeCompanyId?: string;
    jobPositionId?: string;
    departmentId?: string;
    areaId?: string;
    jobCategoryId?: string;
    processNumber?: number;
    businessUnitId?: string;
    inactiveReasonId?: string;
    cityId?: string;
    personalRequisitionId?: string | null;
    vacancyId?: string | null;
    inactivatedOn?: string;
    inactivatedBy?: number;
    otherInactiveReason?: string;
    inactiveComments?: string;
    payrollDate?: string;
    payrollInactivatedOn?: string;
    credentials?: UserCredentialsWithRelations;
    userTenant?: UserTenantWithRelations;
    company?: CompanyWithRelations;
    jobPosition?: JobPositionWithRelations;
    department?: DepartmentWithRelations;
    area?: AreaWithRelations;
    jobCategory?: JobCategoryWithRelations;
    businessUnit?: BusinessUnitWithRelations;
    inactiveReason?: InactiveReasonWithRelations;
    city?: CityWithRelations;
    personalRequisition?: PersonalRequisitionWithRelations;
    vacancy?: VacancyWithRelations;
}

